"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNodeManager = exports.NetworkNode = void 0;
const logger = __importStar(require("../logger"));
class NetworkNode {
    constructor(url) {
        this.availabilityDate = 0;
        this.url = url;
    }
    isAvailable() {
        return Date.now() >= this.availabilityDate;
    }
    makeUnavailable(duration) {
        this.availabilityDate = Date.now() + duration;
    }
    makeAvailable() {
        this.availabilityDate = 0;
    }
}
exports.NetworkNode = NetworkNode;
const shuffleArray = (array) => {
    const shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }
    return shuffledArray;
};
const createNodeManager = ({ nodeUrls, useStickyNode = false, unavailableDuration = 5000, }) => {
    const nodes = nodeUrls.map(url => new NetworkNode(url));
    return {
        nodes,
        stickedNode: null,
        useStickyNode: useStickyNode,
        lastUsedNode: null,
        getAvailableNodes(customRecoveryThreshold) {
            const availableNodes = this.nodes.filter((node) => node.isAvailable());
            if (this.nodes.length >= 3) {
                // Default to conservative threshold (2x formula) if no custom threshold provided
                const recoveryThreshold = customRecoveryThreshold !== null && customRecoveryThreshold !== void 0 ? customRecoveryThreshold : this.nodes.length - Math.floor((2 * (this.nodes.length - 1)) / 3);
                if (availableNodes.length < recoveryThreshold) {
                    logger.debug(`Auto-recovery: ${availableNodes.length} < ${recoveryThreshold} nodes (${this.nodes.length} total)`);
                    const previousStickyUrl = this.stickedNode;
                    this.makeAllNodesAvailable();
                    if (this.useStickyNode && previousStickyUrl) {
                        if (previousStickyUrl) {
                            this.setStickyNode(previousStickyUrl);
                            logger.info(`Sticky node preserved during recovery: ${previousStickyUrl}`);
                        }
                    }
                    const updatedAvailableNodes = this.nodes.filter((node) => node.isAvailable());
                    return shuffleArray(updatedAvailableNodes);
                }
            }
            const shuffledAvailableNodes = shuffleArray(availableNodes);
            // set sticky node as the first node, and then shuffle the rest
            if (useStickyNode && this.stickedNode && this.stickedNode.isAvailable()) {
                const nodesWithoutSticky = shuffledAvailableNodes.filter(node => node !== this.stickedNode);
                return [this.stickedNode, ...nodesWithoutSticky];
            }
            return shuffledAvailableNodes;
        },
        setStickyNode(node) {
            this.stickedNode = node;
        },
        setUseStickyNode(useSticky) {
            this.useStickyNode = useSticky;
        },
        getNode() {
            const nodes = this.getAvailableNodes();
            if (nodes.length === 0) {
                return null;
            }
            const index = Math.floor(Math.random() * nodes.length);
            const node = nodes[index];
            this.lastUsedNode = node;
            if (!this.useStickyNode) {
                return node;
            }
            if (!this.stickedNode) {
                this.setStickyNode(node);
                return node;
            }
            this.lastUsedNode = this.stickedNode;
            return this.stickedNode;
        },
        makeAllNodesAvailable() {
            for (const node of this.nodes) {
                node.makeAvailable();
            }
        },
        makeNodeUnavailable(nodeUrl, duration = unavailableDuration) {
            if (this.stickedNode && this.stickedNode.url === nodeUrl) {
                this.stickedNode = null;
            }
            const invalidNode = this.nodes.find((node) => node.url === nodeUrl);
            if (!invalidNode)
                return;
            invalidNode.makeUnavailable(duration);
        },
    };
};
exports.createNodeManager = createNodeManager;
//# sourceMappingURL=nodeManager.js.map